import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  type InputSignal,
  type Signal,
} from '@angular/core';
import { UiBadgeTone } from '../../types/ui-badge-tone.type';

@Component({
  selector: 'ui-badge',
  imports: [],
  templateUrl: './ui-badge.component.html',
  styleUrl: './ui-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiBadgeComponent {
  public readonly tone: InputSignal<UiBadgeTone> = input<UiBadgeTone>('neutral');

  protected readonly isNeutral: Signal<boolean> = computed((): boolean => this.tone() === 'neutral');
  protected readonly isSuccess: Signal<boolean> = computed((): boolean => this.tone() === 'success');
  protected readonly isWarning: Signal<boolean> = computed((): boolean => this.tone() === 'warning');
  protected readonly isAccent: Signal<boolean> = computed((): boolean => this.tone() === 'accent');
  protected readonly isDanger: Signal<boolean> = computed((): boolean => this.tone() === 'danger');
}
